export const ENTRY_TYPES = [
  { value: 'preseason', label: 'Preseason' },
  { value: 'trail_cameras', label: 'Trail Cameras' },
  { value: 'public_land', label: 'Public Land' },
  { value: 'small_property', label: 'Small Property' },
  { value: 'hunts', label: 'Hunts' },
  { value: 'lessons', label: 'Lessons' },
  { value: 'results', label: 'Results' },
];

export const FIELD_NOTE_CATEGORIES = [
  { value: 'scouting', label: 'Scouting' },
  { value: 'trail_cameras', label: 'Trail Cameras' },
  { value: 'public_land', label: 'Public Land' },
  { value: 'small_properties', label: 'Small Properties' },
  { value: 'hunt_recaps', label: 'Hunt Recaps' },
  { value: 'lessons', label: 'Lessons' },
  { value: 'behind_the_camera', label: 'Behind the Camera' },
  { value: 'gear_i_actually_use', label: 'Gear I Actually Use' },
];

export const CONTACT_REASONS = [
  { value: 'general', label: 'General message' },
  { value: 'brand_partnership', label: 'Brand partnership' },
  { value: 'podcast_media', label: 'Podcast or media request' },
  { value: 'collaboration', label: 'Collaboration' },
  { value: 'website_issue', label: 'Website issue' },
];

export const labelFor = (list, value) => list.find((x) => x.value === value)?.label ?? value;

export function youtubeId(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    if (u.hostname.includes('youtu.be')) return u.pathname.slice(1);
    if (u.searchParams.get('v')) return u.searchParams.get('v');
    const parts = u.pathname.split('/');
    const i = parts.indexOf('embed');
    if (i !== -1 && parts[i + 1]) return parts[i + 1];
  } catch {
    return null;
  }
  return null;
}

export function youtubeEmbedUrl(url) {
  const id = youtubeId(url);
  return id ? `https://www.youtube.com/embed/${id}` : null;
}

export function formatDate(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return '';
  }
}
